export default __webpack_public_path__ + "static/media/cloud-2.3c842431.webp";